module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_vtrusguard_m.f5477680dfa2e57ae08460b6f98ad944.png";